export const LocalRoutes = {
    Root: '/',
    ZoneRoot: '/zone/',
    Zone: '/zone/:zoneGuid',
    AcceptInvitation: '/user/acceptinvitation/:guid',
    RegisterWithInvitation: '/invitation/register/:guid',

    Login: '/account/login',
    LoginAdvanced: '/account/login/:guid',
    Logout: '/account/logout',
    ForgotPassword: '/account/forgotpassword',
    ResetPassword: '/account/resetpassword',

    UserSettings: '/user/settings',
    UserTasks: '/tasks',
    UserReportList: '/userreports',
    UserZoneProfile: '/userzoneprofile',
    TaskBarSetting: '/taskbarsettings',

    Admin: '/admin',
    AssertionDescriptors: '/admin/assertiondescriptors',
    AssertionDescriptorNew: '/admin/assertiondescriptor',
    AssertionDescriptorDetail: '/admin/assertiondescriptor/:guid',
    CreateInvitation: '/admin/invitation',
    Users: '/admin/users',
    UserDetail: '/admin/user/:guid',
    Zones: '/admin/zones',
    ZoneDetail: '/admin/zone/:guid',
    ZoneNew: '/admin/zone',
    OrganizationDetail: '/admin/organization/:guid',

    PackageSettlementDetailExportID: '/packageSettlementDetailExport/',
    PackageSettlementDetailExport: '/packageSettlementDetailExport/:guid',

    Cases: '/cases',
    CaseFileNew: '/case/new',
    CaseFile: '/case/:guid',
    CaseAssessment: '/caseassessment/:guid',
    CaseEasyUpdate: '/easyupdate',
    CasePlan: '/caseplan/:guid',
    CasePlanTaskDetail: '/caseplantask/:caseguid/:caseplanguid/:taskguid',
    WorkProductDetail: '/workproduct/:entityguid/:entitytypeid/:documentguid?',
    CaseResolution: '/caseresolution/:resolutionguid/case/:guid',

    PackageSettlements: '/packagesettlements',
    PackageSettlementDetails: '/packagesettlement/:guid',
    PackageSettlementNew: '/packagesettlement/',

    ReportTypeList: '/reporttypes',
    ReportDetail: '/reports/:id',
    AutoExportReport: '/autoexportreport/:id',
    Query: '/query',
    QueryLegacy: '/query-legacy',
    ZoneNotes: '/zonenotes',
    MyDocuments: '/mydocuments',

    // Zone Specific Local Routes. This will match dbo.OrganizationReportSetting.Url or dbo.ReportType.Url
    WeeklyRecap: '/weeklyrecap',
    WeeklyRecapCollab: '/weeklyrecap/:guid',
    WeeklyRecapLegacy: '/weeklyrecaplegacy',

    MonthlyRecap: '/monthlyrecap',
    MonthlyRecapCollab: '/monthlyrecap/:guid',
    MonthlyRecapLegacy: '/monthlyrecaplegacy',

    KpiReport: '/kpireport',
    KpiReportCollab: '/kpireport/:guid',
    KpiReportLegacy: '/kpilegacy',

    Trends: '/trends',

    Board: '/board',
    BoardCaseDetail: '/boardcasedetail',
    BoardViewDetail: '/boardviewdetail',

    Experts: '/experts',
    ExpertCreate: '/experts/new',
    ExpertDetail: '/experts/:id',
    ExpertsDetails: '/experts/:guid',

    CaseExpertDetail: '/caseexpert/:id',

    AccessDenied: '/accessdenied',
    NotFound: '/not-found',

    StrategicPlan: '/strategicplan',
    StrategyExecutionPlan: '/strategyexecutionplan',
    Strategy: '/strategy/:type',

    PlaintiffFirmStrategyDetail: '/plaintifffirmstrategydetail/:guid',
    JurisdictionStrategyDetail: '/jurisdictionstrategydetail/:guid',
    LocalCounselStrategyDetail: '/localcounselstrategydetail/:guid',

    PlaintiffFirmStrategyNew: '/plaintifffirmstrategydetail/',
    JurisdictionStrategyNew: '/jurisdictionstrategydetail/',
    LocalCounselStrategyNew: '/localcounselstrategydetail/',

    Projects: '/projects',
    ProjectDetail: '/project/:guid',
    ProjectNew: '/project/',
    MeetingAgenda: '/meetingagenda/:guid',

    Snapshot: '/snapshot',
    Alerts: '/alerts/:type',
    ViewPDF: '/viewpdf',
    ViewSpecificPDF: '/tutorials/viewpdf/:id',
    Tutorials: '/tutorials',

    Triggers: '/triggers',
    TriggerNew: '/triggers/new',
    TriggerDetails: '/trigger/:triggerGuid',

    Quad: '/quad',
    QuadDashboard: '/quad/dashboard',
    QuadCaseList: '/quad/same-cases',
    QuadZoneNoteCreate: '/quad/zone-note/create',
    QuadTriggerRuleCreate: '/quad/trigger-rule/create',
    QuadQuery: '/quad/query',

    QuadSameCase: '/quad/same-case/:sameCaseGuid',
    QuadSameCaseEasyUpdate: '/quad/same-case/:sameCaseGuid/easy-update/',
    QuadMessages: '/quad/messages',
    QuadUserSettings: '/quad/user/settings',
    QuadCaseResolution: 'quad/case-resolution',

    QuadAdminSameCaseManage: '/quad/admin/manage-same-cases',
    QuadAdminSameCaseSearch: '/quad/admin/search-same-cases',

    Announcement: '/quad/announcement/:announcementContentGuid',
    Announcements: '/quad/announcements',
};
